import React, { useEffect } from "react";
// 引入 AOS 動畫庫與樣式檔，用於頁面進場動效
import Aos from "aos";
import "aos/dist/aos.css";
// 引入本元件對應的 CSS 樣式
import "./signature.css";
// 引入 React Router 的 Link，用於頁面導覽
import { Link } from "react-router-dom";

// 引入所需圖示
import { HiOutlineLocationMarker, HiOutlineClipboardCheck } from "react-icons/hi";

// 引入圖片資源
import img1 from "../../Assets/signImg/img1.png";

/*
  Data 陣列儲存行程相關資訊：
  - id: 行程識別碼
  - imgSrc: 行程對應圖片
  - destTitle: 行程標題
  - location: 行程地點
  - grade: 適合年級
  - fees: 費用資訊
  - description: 行程描述
*/
const Data = [
  {
    id: 1,
    imgSrc: img1,
    destTitle: "攜子之手 - 加拿大溫馨親子夏令營",
    location: "🇨🇦 · 加拿大 · 多倫多",
    grade: "K-8",
    fees: "9500 加元/雙人（學生+家長）；5000 加元 / 每增加一位小朋友",
    description:
      "從娃娃抓起的留學體驗；融入本地學生的私校課程；豐富的文化體驗活動；週末觀光度假；陪讀父母的專屬行程；私校留學考察",
  },
];

/*
  Signature1 元件：
  - 使用 AOS 為元素添加淡入動畫。
  - 透過 Data 陣列動態渲染行程資訊。
  - 顯示回到主頁的按鈕。
*/
export default function Signature1() {
  // 在元件掛載時初始化 AOS，設定動畫持續時間為 2000 毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區域 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          攜 子 之 手 - 加 拿 大 溫 馨 親 子 夏 令 營
        </h3>
        <button className="signHomeBtn">
          <Link to={"/"} className="signHomeBtnLink">
            返 回 主 頁
          </Link>
        </button>
      </div>

      {/* 行程內容區，使用 Grid 佈局 */}
      <div className="signSecContent signGrid">
        {Data.map(
          ({ id, imgSrc, destTitle, location, company, fees, description }) => {
            return (
              <div key={id} data-aos="fade-up" className="signSingleDestination">
                {/* 左側文字資訊區塊 */}
                <div className="signCardInfo">
                  <h4 className="signDestTitle">{destTitle}</h4>
                  <span className="signContinent signFlex">
                    <HiOutlineLocationMarker className="icon" />
                    <span className="signName">{location}</span>
                  </span>

                  {/* 行程特色區塊 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        執行機構：{company}
                        <br />
                        <br />
                        <small>⭐️ 行 程 特 色</small>
                        <br />
                        <br />
                      </span>
                    </div>
                    <div>
                      <p>{description}</p> <br />

                      {/* 行程詳細特色表格 */}
                      <table width="70%">
                        <thead>
                          <tr>
                            <th width="20%"></th>
                            <th width="10%"></th>
                            <th width="70%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>沉浸式體驗</td>
                            <td></td>
                            <td>入學加拿大本土私校，純英文環境，完全融入當地孩子的暑期生活；</td>
                          </tr>
                          <br />
                          <tr>
                            <td>家長陪同</td>
                            <td></td>
                            <td>全程親子陪同，增進學生與家長的親密關係</td>
                          </tr>
                          <br />
                          <tr>
                            <td>課後活動</td>
                            <td></td>
                            <td>豐富的課後本土活動，體驗加拿大純正的市民生活</td>
                          </tr>
                          <br />
                          <tr>
                            <td>未來規劃</td>
                            <td></td>
                            <td>
                              全面考察加拿大的教育、生活、社會，為學生未來國際化學習提供規劃
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* 參團資訊區塊 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 團 信 息</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <br />
                    <table width="70%">
                      <thead>
                        <tr>
                          <th width="15%"></th>
                          <th width="10%"></th>
                          <th width="75%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>招生對象</td>
                          <td></td>
                          <td>6歲-15歲中小學生</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 間</td>
                          <td></td>
                          <td>2024年6月-7月</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 長</td>
                          <td></td>
                          <td>14天</td>
                        </tr>
                        <br />
                        <tr>
                          <td>地 點</td>
                          <td></td>
                          <td>加拿大多倫多市</td>
                        </tr>
                        <br />
                        <tr>
                          <td>活動內容</td>
                          <td></td>
                          <td>
                            私校夏令營，博物館、森林公園、度假屋、
                            採購、品酒、社區考察
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>夏令營課程</td>
                          <td></td>
                          <td>
                            體育：球類運動，趣味游泳課程；語言類課程；手工製作與創新；電腦程式設計；數學；趣味科學
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>費 用 包 括</td>
                          <td></td>
                          <td>
                            學生在私立學校夏令營團費、留學規劃諮詢服務、留學申請服務。家長和學生兩人簽證申請服務、在加拿大期間的餐飲費用、住宿費用、交通費用、門票及相關費用。
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>費 用 不 包 括</td>
                          <td></td>
                          <td>
                            公證、簽證等手續費用，往返國際機票，國際旅行醫療保險、意外保險，全程的購物，景區的個人消費，賭場、靶場消費
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 參考行程區塊 */}
                  <div className="signFees">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 考 行 程</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <br />
                    <p>
                      兩週行程示例；實際活動內容會有前後調整；或被相近內容替代；夏令營正式開始前兩週確定具體行程。
                    </p>
                    <br />
                    <table width="100%">
                      <thead>
                        <tr>
                          <th width="10%">日期</th>
                          <th width="50%">活動</th>
                          <th width="40%">課後活動</th>
                        </tr>
                      </thead>
                      <tbody>
                        <br />
                        <tr>
                          <td>週六</td>
                          <td>中國出發</td>
                          <td>接機，抵達賓館休整</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>尼亞加拉小鎮、大瀑布觀光；奧特萊斯購物</td>
                          <td>遊覽、購物</td>
                        </tr>
                        <br />
                        <tr>
                          <td>週一</td>
                          <td>
                            私校夏令營報到，第一日 / 家長超市購物，了解加拿大市民消費
                          </td>
                          <td>歡迎晚宴，休息調整時差</td>
                        </tr>
                        <tr>
                          <td>週二</td>
                          <td>
                            私校夏令營第二日 / 家長參觀當地不同檔次社區，售房樣板間和居住環境
                          </td>
                          <td>一同參觀社區活動中心及圖書館等生活設施</td>
                        </tr>
                        <tr>
                          <td>週三</td>
                          <td>
                            私校夏令營第三日 / 家長參觀私校校園，與招生老師交流，了解私校留學等資訊
                          </td>
                          <td>學生與招生老師交流</td>
                        </tr>
                        <tr>
                          <td>週四</td>
                          <td>私校夏令營第四日 / 家長到多倫多最大購物中心購物</td>
                          <td>遊覽歐洲風情古老社區</td>
                        </tr>
                        <tr>
                          <td>週五</td>
                          <td>私校夏令營第五日 / 家長參加海外留學答疑講座</td>
                          <td>週末夏季美食、音樂節戶外活動</td>
                        </tr>
                        <br />
                        <tr>
                          <td>週六</td>
                          <td>週末戶外野營小屋體驗、品酒、烤肉、徒步、划船</td>
                          <td>親子週末休閒遊</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>週末戶外野營小屋體驗、品酒、烤肉、徒步、划船</td>
                          <td>親子週末休閒遊</td>
                        </tr>
                        <br />
                        <tr>
                          <td>週一</td>
                          <td>
                            私校夏令營報到，第六日 / 家長至合法賭場（自費）體驗休閒活動
                          </td>
                          <td>超市日常採購</td>
                        </tr>
                        <tr>
                          <td>週二</td>
                          <td>私校夏令營第七日 / 家長至Fairview休閒購物</td>
                          <td>參觀消防局等市民服務機構</td>
                        </tr>
                        <tr>
                          <td>週三</td>
                          <td>
                            私校夏令營第八日 / 家長到合法靶場（自費）體驗休閒活動
                          </td>
                          <td>參觀古老火車站，古董火車乘車體驗</td>
                        </tr>
                        <tr>
                          <td>週四</td>
                          <td>私校夏令營第九日 / 家長參觀多倫多大學、招生處答疑</td>
                          <td>社區公園娛樂並戶外野餐</td>
                        </tr>
                        <tr>
                          <td>週五</td>
                          <td>私校夏令營第十日 / 家長至奧特萊斯購物</td>
                          <td>樂高創意中心</td>
                        </tr>
                        <br />
                        <tr>
                          <td>週六</td>
                          <td>多倫多市內參觀：老市政廳、CN電視塔、百年集市、卡薩羅馬古堡</td>
                          <td>歡送晚宴</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>返程日</td>
                          <td>順利回家</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 費用與預報名按鈕 */}
                  <div className="signPrice">
                    <h5>預 售 價 格 ：{fees}</h5>
                  </div>
                  <Link to={"/formReg"} target="_blank">
                    <button className="signBtn signFees">
                      <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
                    </button>
                  </Link>
                </div>

                {/* 右側圖片區 */}
                <div className="signImageDiv">
                  <img src={imgSrc} alt={destTitle} />
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
}